import { render, staticRenderFns } from "./ClientBranchModal.vue?vue&type=template&id=9e8b391c&"
import script from "./ClientBranchModal.vue?vue&type=script&lang=js&"
export * from "./ClientBranchModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports